"use strict";

// ---------------------------------------------------
// Dependencies

var SoaModel = require('bunsen/models/SoaModel');
var root = typeof window === 'undefined' ? global : window;
var Item = root.bunsen.Item = module.exports =  SoaModel.extend();
var SoaCollection = require('bunsen/collections/SoaCollection');
var Backbone = require('dibs-backbone');
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var assert = require('bunsen/helpers/assert');
var Seller = require('bunsen/models/Seller');
var Photo = require('bunsen/models/inventory/Photo');
var Holds = require('bunsen/collections/inventory/Holds');
var itemPhotosMixin = require('bunsen/models/mixins/ItemPhotosMixin');
var endpoints = require('dibs-endpoints');
var Listing = require('bunsen/models/inventory/Listing');
var ShipmentQuotes = require('bunsen/collections/logistics/ShipmentQuotes');
var ItemAttributesModel = require('bunsen/models/inventory/ItemAttributes');
var ItemAttributesCollection = require('bunsen/collections/inventory/ItemAttributes');
var ItemCreator = require('bunsen/models/link-models/ItemCreator');
var ItemCreators = require('bunsen/collections/inventory/ItemCreators');
var StorefrontPreferences = require('bunsen/models/inventory/StorefrontPreferences');
var ReturnPolicy = require('bunsen/models/identity/ReturnPolicy');
var Condition = require('bunsen/models/inventory/Condition');
var Party = require('bunsen/models/Party');
var Mailer = require('bunsen/models/inventory/Mailer');
var ItemCategories = require('bunsen/collections/inventory/ItemCategories');
var Category = require('./Category');
var ItemPricing = require('bunsen/models/inventory/ItemPricing');
var verticals = require('dibs-vertical-helpers');
var FinancialAmount = require('bunsen/models/FinancialAmount');
var Measurement = require('bunsen/models/inventory/Measurement');
var transitionMixin = require('bunsen/models/mixins/transitionMixin');
var NotesDocumentList = require('bunsen/models/NotesDocumentList');
var ListingDocumentList = require('bunsen/models/inventory/ListingDocumentList');
var ReviewDocumentList = require('bunsen/models/inventory/ReviewDocumentList');
var Review = require('bunsen/models/inventory/Review');
var AvailableActions = require('bunsen/collections/AvailableActions');
var Deferred = require('simply-deferred');
var User = require('bunsen/models/identity/User');
var itemDisplayStatus = require('../../helpers/itemDisplayStatus.es');
var currencies = require('dibs-currency-helpers/constants').currencies;
var Price = require('./Price.es');

// ---------------------------------------------------
// Local Vars

var HasOne = Backbone.One;
var HasMany = Backbone.Many;
var relations;
var docListShell = { metadata: {}, documents: [] };
var actionNames;

// graphql transforms all Y/N's into true/false
// make sure we can accomodate both
function isYes(prop) {
    return prop === 'Y' || prop === true;
}

root.bunsen = root.bunsen || {};

// ---------------------------------------------------
// Module Definition


relations = [
    {
        key: 'holds',
        type: HasMany,
        collectionType: Holds
    },
    {
        key: 'creators',
        relatedModel: ItemCreator,
        type: HasMany,
        collectionType: ItemCreators
    },
    {
        key: 'classification',
        type: HasOne,
        relatedModel: SoaModel.extend({
            relations: [{
                key: 'style',
                type: HasOne,
                relatedModel: SoaModel
            }, {
                key: 'categories',
                type: HasMany,
                collectionType: ItemCategories
            }]
        })
    },
    {
        key : 'attributes',
        relatedModel: ItemAttributesModel,
        type: HasOne
    },
    {
        key: 'materialsTechniques',
        collectionType: ItemAttributesCollection,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'measurement',
        relatedModel: Measurement,
        type: HasOne
    },
    {
        key: 'shipmentQuotes',
        collectionType: ShipmentQuotes,
        type: HasMany,
        omitFromSave: true
    },
    {
        key: 'pricing',
        relatedModel: ItemPricing,
        type: HasOne
    },
    {
        key: 'condition',
        relatedModel: Condition,
        type: HasOne
    },
    {
        key: 'listings',
        relatedModel: ListingDocumentList,
        type: HasOne
    },
    {
        key: 'customMaterial',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'updateRestrictionList',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'store',
        type: HasOne,
        relatedModel: SoaModel
    },
    {
        key: 'seller',
        relatedModel: Seller,
        type: HasOne
    },
    {
        type: HasMany,
        key: 'photos',
        relatedModel: Photo
    },
    {
        key: 'reviews',
        relatedModel: ReviewDocumentList,
        type: HasOne
    },
    {
        key: 'returnPolicy',
        relatedModel: ReturnPolicy,
        type: HasOne
    },
    {
        key: 'mailer',
        type: HasOne,
        relatedModel: Mailer
    },
    {
        key: 'storefrontPreferences',
        type: HasOne,
        relatedModel: StorefrontPreferences
    },
    {
        key: 'versions',
        type: Backbone.Many,
        collectionType: SoaCollection.extend({
            model: SoaModel.extend({
                relations: [{
                    key: 'price',
                    type: HasOne,
                    relatedModel: FinancialAmount
                }]
            })
        })
    },
    {
        key : 'actions',
        type: Backbone.Many,
        collectionType: AvailableActions
    },
    {
        key: 'notes',
        type: HasOne,
        relatedModel: NotesDocumentList
    }
];

_.extend(Item.prototype, {

    relations: relations,

    // NOTE: THIS IS COPY-PASTA FROM ITEM V2
    // original comment:
    // In Backbone JS - the parse function is automatically called whenever you get model data back from the server. It
    // should return a hash map of attributes to be set on the model. In our case, we use 2 different end points for
    // fetch and save, so this function figures out which endpoint was hit, and grabs the correct data:
    parse: function (data) {
        var defaultsMap = {
            fashion: Item.getFashionDefaults,
            jewelry: Item.getJewelryDefaults,
            art: Item.getArtDefaults
        };

        data = SoaModel.prototype.parse.apply(this, arguments);

        if (data && data.vertical) {
            if (typeof defaultsMap[data.vertical] === 'function') {
                data = $.extend(true, {}, defaultsMap[data.vertical](), data);
            }
        }
        return data;
    },

    getAmountPerItem : function (currency) {
        var quantity = parseInt(this.get('pieces') || 0, 10);
        var pricing = this.get('pricing');
        var amount;

        if (!pricing) {
            return undefined;
        }

        amount = pricing.getTotalAmount(currency);
        if (this.isSoldIndividually()) {
            return amount / quantity;
        }
        return amount;
    },
    canMultipleQuantityBePurchased: function () {
        return this.get('pricing.pricePerPiece') === 'Y' && this.get('pieces') > 1;
    },
    dealerSuspended: function () {
        return this.get('seller') && this.get('seller').isStatusSuspended();
    },
    dealerClosed: function () {
        return this.get('seller') && this.get('seller').isStatusClosed();
    },
    dealerPending: function () {
        return this.get('seller') && this.get('seller').isStatusPending();
    },
    /**
     * This is subject to change since new price types (NET, WEEKLY_SALE)
     * could also have a hidden price.  Currently it only checks for the
     * active retail price.
     * @return {Boolean}
     */
    isPriceHidden: function () {
        var activePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.isRetail();
        });
        return !!(activePrice && activePrice.shouldHidePrice());
    },
    /*
     * Return if a price is hidden based on the provided type
     * @param {string} type The Price type, from Price.TYPE_*
     * @retur {Boolean}
     */
    isPriceHiddenByType: function (type) {
        var activePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.get('type') === type;
        });
        if (type === Price.TYPE_NET && typeof activePrice === 'undefined') {
            return true;
        }
        return !!(activePrice && activePrice.shouldHidePrice());
    },
    /*
     * Return if a price is negotiable based on the provided type
     * @param {string} type The Price type, from Price.TYPE_*
     * @retur {Boolean}
     */
    isNegotiablePriceByType: function (type) {
        var typePrice = this.get('pricing.prices') && this.get('pricing.prices').find(function (price) {
            return price.isActive() && price.get('type') === type;
        });
        return !!(typePrice && typePrice.isNegotiable());
    },
    /**
     * Returns formatted price for
     * @param {string} options.currency currency to which this item's price will be formatted.
     * @param {boolean} options.includeCurrencySymbol if false, the currency symbol will be omitted from the return value.
     * @returns {string} local-formatted price string, when options is {currency: "EUR", includeCurrencySymbol: true} and item price is 123456.78, returns "€123.456,78".
     */
    localizedAmount: function (options) {
        var totalAmount = this.get('pricing.totalAmount');
        if (totalAmount) {
            return totalAmount.localizedAmount(options);
        }
    },
    /**
     * Finds and returns pricing details on the item.
     * @returns {String}
     * @public
     */
    getDisplayPrice: function (currency) {
        var amount;
        if (this.isPriceHidden()) {
            return 'Price Upon Request';
        } else {
            amount = this.get('pricing.totalAmount');
            return amount && amount.getDisplayPrice(currency);
        }
    },
    getConvertedPriceAmount: function (currency) {
        var prop = 'pricing.totalAmount.convertedAmounts.' + currency;
        return this.get(prop);
    },
    /**
     * method that gets converted amounts based on "RETAIL", "NET", "WEEKLY_SALE" price types
     * @param {string} type
     * @returns {object|null}
     */
    getConvertedPriceAmountsByType: function (type) {
        var prices = this.getPriceByType(type);
        return prices ? prices.get('amount.convertedAmounts') : null;
    },
    getCurrency: function () {
        return this.get('pricing.totalAmount.currency');
    },
    getPrice: function () {
        return this.get('pricing.totalAmount.amount');
    },
    getPriceLocksByType: function (type) {
        var pricing = this.get('pricing');
        return pricing.getPriceLockByType(type);
    },
    getPriceLocksIn: function (type, currency) {
        var priceLock = this.getPriceLocksByType(type);
        var amount;
        currency = currency || currencies.CURRENCY_USD;
        if (priceLock) {
            // FinancialAmount model
            amount = priceLock.getOriginalPriceIn(currency);
            if (amount) {
                return amount;
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getPriceByType: function (type) {
        var pricing = this.get('pricing');
        return pricing && pricing.getPriceByType(type);
    },
    getPriceIn: function (type, currency) {
        var price = this.getPriceByType(type);
        var amount;
        currency = currency || currencies.CURRENCY_USD;
        if (price) {
            // FinancialAmount model
            amount = price.get('amount');
            if (amount) {
                return amount.getAmountIn(currency);
            }
        }
        // return null so that it's easy
        // to detect whether or not there is a price
        return null;
    },
    getNumberOfPieces: function () {
        return this.get('pieces');
    },
    soldIndividually: function () {
        return this.get('pricing') && isYes(this.get('pricing.pricePerPiece'));
    },
    _isVertical: function (vertical) {
        return this.get('vertical') === vertical;
    },
    isArt: function () {
        return this._isVertical(verticals.VERTICAL_ART);
    },
    isFashion: function () {
        return this._isVertical(verticals.VERTICAL_FASHION);
    },
    isFurniture: function () {
        return this._isVertical(verticals.VERTICAL_FURNITURE);
    },
    isJewelry: function () {
        return this._isVertical(verticals.VERTICAL_JEWELRY);
    },
    getTotalAmounts: function () {
        return this.get('pricing.totalAmount.convertedAmounts');
    },
    getInitialPriceAmounts: function () {
        return this.get('pricing.initialPrice.convertedAmounts');
    },
    getAmountIn: function (currency) {
        return this.get('pricing.totalAmount').getAmountIn(currency);
    },
    isNegotiablePrice: function () {
        return isYes(this.get('pricing.negotiable'));
    },
    isBargainPrice: function () {
        return isYes(this.get('pricing.bargain'));
    },
    /**
     * Get initial price.  If the item is on sale, the "bargain" price will
     * be in the totalAmount, i.e. you can retrieve it with getDisplayPrice()
     * @param  {String} currency - optional
     * @return {String} price
     */
    getInitialPrice: function (currency) {
        return this.get('pricing.initialPrice').getDisplayPrice(currency);
    },

    hidingPrice: function () {
        var price = this.getPrice();
        return !price || price < 0.01 || this.isPriceHidden();
    },

    // PHOTOS ---------------------------------------------------------------------------------------------------------
    /**
     * Gets the number of photos on the item excluding empty photo objects (ones with no versions)
     * @returns {*}
     */
    getNumPhotos : function () {
        return this.get('photos')
            .filter(function (photo) {
                return photo && photo.get('versions') && photo.get('versions').length;
            }).length;
    },

    /**
     * Returns an array of photo URLs by size. ie. get all large or thumbnail photos
     * @param size <string> ie. "large"
     * @returns {Array}
     */
    getPhotosBySize : function (size) {
        var sizedPhoto;

        return this.getPhotos()
            .filter(function (photo) {
                sizedPhoto = photo.getVersion(size);
                return sizedPhoto && sizedPhoto.get('webPath');
            });
    },

    /**
     * @param options
     * @param [options.position=1] {number} the photo position
     * @param [options.size=small] {string} the photo size
     * @returns {string}
     */
    getPhotoUrl: function (options) {
        options = options || {};
        options.position = options.position || 1;
        options.size = options.size || 'small';

        assert((_.indexOf(itemPhotosMixin.photoTypes, options.size) !== -1), 'Invalid photo version provided');

        try {
            return this.getPhotos()
                .findWhere({ sortOrder: options.position })
                .getVersion(options.size)
                .get('webPath');
        } catch (e) {
            console.error('Photo not found', this.id, options);
        }
    },

    supports21stCenturyData: function () {
        return this.isFurniture();
    },
    getPeriod: function () {
        return this.get('attributes.period[0].value');
    },
    getCreator: function () {
        return this.get('creators[0].creator.name');
    },
    /**
     * Looks through the item's collection of creators and returns an array of creators whose 'roles' array contains roleToFind
     * @param {string} roleToFind
     * @returns {array}
     */
    getCreatorsByRole: function (roleToFind) {
        assert(roleToFind, 'A role must be passed as the argument to getCreatorsByRole');
        return this.getCreatorsCollection()
            .filter(function (creator) {
                return _.contains(creator.get('roles'), roleToFind.toUpperCase());
            });
    },
    /**
     * Returns array of creator names.
     * @return {Array} array of strings
     */
    getCreators: function () {
        var creators = this.get('creators');
        var creatorDisplayNames = [];
        var creatorIdentifierField;

        if (this.isFashion() || this.isJewelry()) {
            creatorIdentifierField = 'name';
        } else {
            creatorIdentifierField = 'displayName';
        }

        // check if the creators collection is defined, and if so,
        // send the creator display names (if any) to the template
        if (creators) {
            // iterate over the creators collection
            creators.each(function (creatorModel) {
                var displayName = creatorModel.get('creator.' + creatorIdentifierField);
                if (!_.isUndefined(displayName) && !_.contains(creatorDisplayNames, displayName)) {
                    creatorDisplayNames.push(displayName);
                }
            });
        }

        return creatorDisplayNames;
    },
    /**
     * Returns array of creator names. Each element is an object with an attribution and an array
     * of creator names for that attribution.
     * @returns {Array}
     */
    getCreatorsNamesByAttribution: function () {
        var creators = this.get('creators');
        var creatorDisplayNames = [];
        var creatorIdentifierField;

        if (this.isFashion() || this.isJewelry()) {
            creatorIdentifierField = 'name';
        } else {
            creatorIdentifierField = 'displayName';
        }

        // check if the creators collection is defined, and if so,
        // send the creator display names (if any) to the template
        if (creators) {
            // iterate over the creators collection
            creators.each(function (creatorModel) {
                var attribution;
                var attributionRecord;
                var displayName = creatorModel.get('creator.' + creatorIdentifierField);

                if (!_.isUndefined(displayName)) {
                    attribution = creatorModel.get('attribution') || 'Creator';
                    attributionRecord = _.findWhere(creatorDisplayNames, {attribution: attribution});

                    // create array of names organized by attribution
                    if (attributionRecord) {
                        attributionRecord.creator.push(displayName);
                    } else {
                        creatorDisplayNames.push({
                            attribution: attribution,
                            creator: [displayName]
                        });
                    }
                }
            });
        }

        return creatorDisplayNames;
    },
    getCreatorsCollection: function () {
        var creators = this.get('creators');

        if (creators) {
            return creators;
        }

        this.set('creators', new ItemCreators());

        return this.get('creators');
    },
    getCategory: function (level) {
        var categories = this.get('classification.categories');
        if (_.isArray(categories) && categories[0] && categories[0][level - 1]) {
            return categories[0][level - 1].label;
        }
    },

    /**
     * @returns {ItemCategories}
     */
    getItemCategories : function () {
        return this.get('classification.categories');
    },

    /**
     * Return the primary item category, if one exists
     * @returns {ItemCategory}
     */
    getPrimaryItemCategory: function () {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.getPrimary();
        }
        return null;
    },

    /**
     * @param {string} itemCategoryKey
     * @returns {ItemCategory}
     */
    findItemCategoryByKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (itemCategories) {
            return itemCategories.findByCategoryKey(itemCategoryKey);
        }
        return null;
    },

    _ensureHasItemCategories : function () {
        var itemCategories = this.getItemCategories();
        var classification;
        if (itemCategories) {
            return itemCategories;
        }
        classification = this.get('classification');
        if (!classification) {
            this.set('classification', { categories: [] });
        } else {
            classification.set('categories', []);
        }
        return this.getItemCategories();
    },

    /**
     * Add a new item category to the end
     * of the item categories collections.
     * @param {string} itemCategoryKey
     * @returns {Item}
     */
    addItemCategoryWithKey: function (itemCategoryKey) {
        var itemCategories = this.getItemCategories();
        if (!itemCategories) {
            itemCategories = this._ensureHasItemCategories();
        }
        itemCategories.addWithKey(itemCategoryKey);
        return this;
    },

    /**
     * Creates ItemCategories models based on the keys
     * passed in, and in the same order.
     * @param {string[]} keys
     * @returns {Item}
     */
    setItemCategoriesWithKeys: function (keys) {
        var itemCategories = this._ensureHasItemCategories();
        itemCategories.resetWithKeys(keys);
        return this;
    },

    /**
     * Searches the full vertical {@link Category} singleton
     * for the model that matches the key of the primary
     * {@link ItemCategory} for this item.
     * @returns {Category}
     */
    findPrimaryCategoryInVerticalCategory : function () {
        var primaryItemCategory = this.getPrimaryItemCategory();
        var categoryKey;
        var vertical;
        var verticalCategory;
        if (!primaryItemCategory) {
            return null;
        }
        categoryKey = primaryItemCategory.getCategoryKey();
        vertical = this.get('vertical');
        if (!vertical) {
            return null;
        }
        verticalCategory = Category.verticalCategoryInstance(vertical);
        return verticalCategory.findChildByKey(categoryKey);
    },

    getCategories: function () {
        var inflatedCategories = this.get('classification.inflatedCategories');
        return (inflatedCategories) ? inflatedCategories[0] : [];
    },

    /**
     * Category URL
     * @returns {string}
     */
    getCategoryURL: function () {
        var categories = this.getCategories();
        var parts = _.pluck(categories, 'label');
        if (parts.length) {
            return '/' + parts.join('/') + '/';
        }
        return '/';
    },

    /**
     * Get name of most specific category
     * @returns {string}
     */
    getLowestCategory: function () {
        var categories = this.getCategories();
        if (categories.length) {
            return (categories[categories.length - 1]).name;
        }
        return '';
    },

    /**
     * Add item to mailer
     * @returns {Deferred}
     */
    addMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.add(options);
    },

    /**
     * Remove item from mailer
     * @returns {Deferred}
     */
    removeMailer: function (options) {
        var mailer = new Mailer(null, { itemId: this.id });
        this.set('mailer', mailer);
        return mailer.remove(options);
    },

    isInMailer: function () {
        return isYes(this.get('mailer.inMailer'));
    },

    /**
     * Indicates if item is shown on storefront after sold
     * @return {Boolean}
     */
    isOnStorefrontWhenSold: function () {
        var listings = this.getListings();
        var metadata = listings.getTypeMetadata(Listing.TYPE.STOREFRONT);
        var hasPublishedSF;
        var isSold = this.isSold();

        // is item published to storefront? check metadata first, then listing documents
        if (metadata && metadata.length) {
            hasPublishedSF = (metadata.indexOf(Listing.STATUS.PUBLISHED) >= 0);
        } else {
            hasPublishedSF = listings.filterStorefront().filterPublished().get('documents').size() > 0;
        }

        return isSold && hasPublishedSF;
    },

    url: function () {
        return endpoints.item(this.get('id'));
    },

    addStorefrontListing: function (types) {
        return this.getListings().addStorefrontListing(types);
    },
    addMarketplaceListing: function (types) {
        return this.getListings().addMarketplaceListing(types);
    },
    addFeaturedListing: function (types) {
        return this.getListings().addFeaturedListing(types);
    },
    addWeeklySaleListing: function (types) {
        return this.getListings().addWeeklySaleListing(types);
    },

    /**
     * Save an item's shipment quotes. Item is required
     * to have an id and a seller object.
     * @param {object} [saveOptions]
     * @returns {Promise}
     */
    saveShipmentQuotes: function (saveOptions) {
        var url = endpoints.itemShipmentQuotes(this.id);
        var shipmentQuotesJson;
        var sellerId = this.get('seller.id');
        saveOptions = _.extend({}, {
            url: url
        }, saveOptions);
        this.get('shipmentQuotes').each(function (quote) {
            if (!quote.get('author')) {
                quote.set('author', {
                    role: Party.ROLE_SELLER,
                    id: sellerId
                });
            }
            quote.set({
                type: 'INVENTORY_POSTING'
            });
        }, this);
        shipmentQuotesJson = this.get('shipmentQuotes').toJSON();
        saveOptions.attrs = { dataList: shipmentQuotesJson };
        return new Item(this.toJSON()).save(null, saveOptions);
    },

    /**
     * Return a PDP url path (e.g. /id-f_1234/ or /furniture/storage-case-pieces/credenzas/id-f_1234/)
     * @param {boolean} isIncludeCategories
     * @returns {string}
     */
    getPDPURL: function (isIncludeCategories) {
        return (isIncludeCategories ? this.getCategoryURL().slice(0, -1) : '') + '/id-' + this.id + '/';
    },

    getPdpUrls : function () {
        return this.get('pdpUrls') || [];
    },

    /**
     * @param {number} nth
     * @returns {string|null}
     */
    getNthPdpUrl : function (nth) {
        var urls = this.getPdpUrls();
        var url = null;
        nth = nth || 0;

        if (urls.length && urls[nth]) {
            url = urls[nth];
        }
        return url;
    },

    isSoldIndividually: function () {
        return isYes(this.get('item.pricing.pricePerPiece'));
    },
    /**
     * fetches all available options for this item. Does not take shipment address
     * into consideration
     * @returns {*}
     */
    fetchAvailableOptions: function () {
        var availableOptions = new ShipmentQuotes();

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(this).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },

    getReviews: function () {
        var reviews = this.get('reviews');
        if (reviews === undefined) {
            reviews = new ReviewDocumentList(docListShell);
            this.set('reviews', reviews);
        }
        return reviews;
    },


    /**
     * Returns the first Data Review that is not Deleted
     * @returns {*}
     */
    getDataReview: function () {
        return this.getReviews()
            .filter(function (review) {
                return review.get('type') === Review.TYPE.DATA_QUALITY
                    && review.get('status') !== Review.STATUS.DELETED;
            })[0];
    },

    /**
     * Returns the first Photo Review that is not Deleted
     * @returns {*}
     */
    getPhotoReview: function () {
        return this.getReviews()
            .filter(function (review) {
                return review.get('type') === Review.TYPE.IMAGE_PROCESSING
                    && review.get('status') !== Review.STATUS.DELETED;
            })[0];
    },

    getPhotos: function () {
        return this.get('photos') || new Backbone.Collection();
    },

    /////////////////
    // Status Getters
    isCompleteStatus: function () {
        return this.getStatus() === Listing.STATUS.COMPLETE;
    },
    isIncompleteStatus: function () {
        return this.getStatus() === Item.STATUS.INCOMPLETE;
    },
    isDeletedStatus: function () {
        return this.getStatus() === Item.STATUS.DELETED;
    },
    isNewStatus: function () {
        return this.getStatus() === Item.STATUS.NEW;
    },
    isUnavailableStatus: function () {
        return this.getStatus() === Item.STATUS.UNAVAILABLE;
    },
    getStatus: function () {
        return this.get('status');
    },
    isNotListed : function () {
        return this.isCompleteStatus() && !this.getListings().hasPublishedListing() && !this.isQueuedForPosting();
    },
    canMakeBuyerOffer: function () {
        return this.isNegotiablePrice() && this.isCompleteStatus() && !this.dealerSuspended() && !this.hidingPrice();
    },
    /**
     * @deprecated
     * Use `isNotListed`
     * @returns {boolean}
     */
    wasUnlisted : function () {
        // if the item has no published listings and the post date exists and is not unix time 0 it was unpublished
        var hasPostingDate = !!this.get('postDate');
        if (hasPostingDate) {
            hasPostingDate = !(new Date(this.get('postDate')).getUTCMilliseconds() === 0);
        }
        return !this.getListings().hasPublishedListing() && hasPostingDate;
    },
    /**
     * an item can be rejected by an internal expert only. So, an item is rejected if it's expert reviews are all
     * deleted. If it has no
     * @returns {boolean}
     */
    isRejected: function () {
        return this.isIncompleteStatus() && this.getReviews().filterRejected().any();
    },

    /**
     * Checks to see if this item was ever rejected
     * @return {Boolean}
     */
    wasEverRejected: function () {
        return this.getReviews().wasRejected();
    },

    /**
     * An item is queued for posting if it is in complete state and has pending (queued) listings.
     * @returns {boolean}
     */
    isQueuedForPosting : function () {
        var isQueued = false;
        if (this.isCompleteStatus()) {
            this.getListings().eachType(function (type, statuses) {
                if (statuses.indexOf(Listing.STATUS.NEW) >= 0 ||
                    statuses.indexOf(Listing.STATUS.COMPLETE) >= 0 ||
                    statuses.indexOf(Listing.STATUS.QUEUED) >= 0) {
                    isQueued = true;
                }
            });
            isQueued = isQueued ||
                this.getListings().filterQueued().any() ||
                this.getListings().filterComplete().any() ||
                this.getListings().filterNew().any();
        }
        return isQueued;
    },
    isNydc: function () {
        return this.isFurniture() && this.has('nydcInfo') && isYes(this.get('nydcInfo').isNydc);
    },
    setNydc: function (bool) {
        if (!this.isFurniture()) { return undefined; }
        this.set('nydcInfo', { apiType: "itemNydcInfo", isNydc: bool ? 'Y' : 'N' });
    },
    /**
     * @param {string} value Either 'Y' or 'N' to indicate NYDC status
     * @param {Object} options
     * @returns {Promise}
     * @private
     */
    _updateNYDCStatus: function (value, options) {
        var self = this;
        return this.save(null, _.extend({
            url: endpoints.toggleNYDCv3(this.get('id')),
            type: 'PUT',
            patch: true,
            data: {
                isNydc: value
            }
        }, options)).done(function () {
            self.setNydc(true);
        });
    },
    /**
     * Add item to NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    addToNYDC: function (options) {
        this._updateNYDCStatus('Y', options);
    },
    /**
     * Remove item from NYDC
     * @param {Object} options
     * @returns {Promise}
     */
    removeFromNYDC: function (options) {
        this._updateNYDCStatus('N', options);
    },

    /////////////////
    // Status Setters
    markComplete: function () {
        this.set('status', Item.STATUS.COMPLETE);
        this.unset('unavailableReasonCode');
    },
    markIncomplete: function () {
        this.set('status', Item.STATUS.INCOMPLETE);
        this.unset('unavailableReasonCode');
    },
    markUnavailable: function () {
        this.set('status', Item.STATUS.UNAVAILABLE);
    },
    markDeleted: function () {
        this.set('status', Item.STATUS.DELETED);
        this.unset('unavailableReasonCode');
    },

    /////////////////
    // Reason Code
    markSold: function () {
        this.markUnavailable();
        this.set('unavailableReasonCode', Item.REASON_CODE.ITEM_SOLD);
    },
    markOnHold: function () {
        this.markUnavailable();
        this.set('unavailableReasonCode', Item.REASON_CODE.ON_HOLD);
    },
    isSold: function () {
        var r = Item.REASON_CODE;
        return this.isUnavailableStatus()
            && [r.ITEM_SOLD, r.SOLD_ON_PLATFORM].indexOf(this.get('unavailableReasonCode')) !== -1;
    },
    isOnHold: function () {
        var onHoldReasonCodes = [Item.REASON_CODE.ON_HOLD, Item.REASON_CODE.ON_HOLD_CUSTOM];
        return this.isUnavailableStatus() && onHoldReasonCodes.indexOf(this.get('unavailableReasonCode')) > -1;
    },
    isOnHoldForCustomer: function () {
        return this.isUnavailableStatus()
          && this.get('unavailableReasonCode') === Item.REASON_CODE.ON_HOLD_CUSTOM;
    },
    isOnHoldForEverybody: function () {
        return this.isUnavailableStatus()
          && this.get('unavailableReasonCode') === Item.REASON_CODE.ON_HOLD;
    },

    ///////////
    // Holds
    getActiveHold: function () {
        var holds = this.get('holds');
        return holds ? holds.getActiveHold() : null;
    },
    getHoldExpirationDate: function () {
        var activeHold = this.getActiveHold();
        return activeHold ? activeHold.getExpirationDate() : null;
    },
    getHoldConversationUrl: function () {
        var activeHold = this.getActiveHold();
        return activeHold ? activeHold.getConversationUrl() : null;
    },
    releaseHold: function () {
        var activeHold = this.getActiveHold();
        var dfd = new Deferred.Deferred();

        return activeHold
            ? activeHold
                .release()
                .save()
            : dfd.reject();
    },


    /**
     * Get the items note collection
     * or create a new collection and set
     * it to the notes attr
     * @returns notes
     */
    getNotes: function () {
        var notes = this.get('notes');
        if (notes === undefined) {
            notes = new NotesDocumentList(docListShell, {service: endpoints.latest.inventory});
            this.set('notes', notes);
        }
        return notes;
    },

    /////////////////
    // Listings
    getListings : function () {
        var listings = this.get('listings');
        if (listings === undefined) {
            listings = new ListingDocumentList(docListShell);
            this.set('listings', listings);
        }
        return listings;
    },
    isListed: function () {
        return this.getListings().hasListings();
    },

    hasListings: function () {
        return this.getListings().size() > 0;
    },

    isRepost: function () {
        return this.getListings().isRepost();
    },

    markUnlisted: function () {
        var listings = this.getListings().filterDeleted({ not: true });
        listings.parents = this.getListings().parents;
        listings.each(function (listing) {
            listing.markDeleted();
            listing.set('deletedReasonCode', Listing.REASON_CODE.UNLISTED);
        });
        return listings;
    },

    // Resets the listings to their previous state from the server or an empty
    resetListings : function () {
        var lastAttrs = this.lastSyncAttributes();
        var listingData = lastAttrs.listings || docListShell;
        var listings;
        this.set('listings', listingData);
        listings = this.getListings();
        listings.filterUnsaved().each(function (listing) {
            listings.remove(listing);
        });
    },

    // backbone state changes
    hasChangedListingsSinceLastSync: function () {
        return this.getListings().some(function (listing) {
            return listing.isNew() || listing.changedSinceLastSync();
        });
    },
    /**
     * Move item to storefront by updating listings
     * @param {PublicationTypes} - types - required - Publication types to add a storefront listing
     * @param {Clump} - clump - optional - pass this if you want to clump your requests
     * @return {Promise}
     */
    moveToStorefront: function (types, clump) {
        var listingDfds;
        var dfd;
        //If the item is already on the storefront, return a rejected promise
        if (itemDisplayStatus(this) === 'storefront') {
            dfd = new Deferred.Deferred();
            listingDfds = [dfd.reject()];
        } else {
            listingDfds = this.getListings().filter(function (listing) {
                return !listing.isStorefront() && !listing.isDeletedStatus();
            }).map(function (listing) {
                listing.markDeleted();
                listing.set('deletedReasonCode', Listing.REASON_CODE.UNLISTED);
                return listing.save(null, {
                    queries: {
                        indexMode: 'sync'
                    },
                    clump: clump
                });
            });
            if (!this.getListings().filterStorefront().filterPublished().any()) {
                listingDfds.push(this.addStorefrontListing(types).save(null, {
                    queries: {
                        indexMode: 'sync'
                    },
                    clump: clump
                }));
            }
        }
        return Deferred.when.apply(Deferred, listingDfds);
    },

    ////////////////////////////
    // actions (state transitions)
    canMarkIncomplete: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.INCOMPLETE}));
    },
    canMarkComplete: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.COMPLETE}));
    },
    canMarkDeleted: function () {
        return !!(this.get('actions') && this.get('actions').findWhere({code : Item.ACTION_NAMES.DELETED}));
    },
    canMarkOnHold: function () {
        //return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES._XXX, userOrSeller);
        return this.getListings().hasPublishedListing() && this.isCompleteStatus();
    },
    canMarkSold: function () {
        //return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES._XXX, userOrSeller);
        return (this.getListings().hasPublishedListing() && this.isCompleteStatus()) || (this.isUnavailableStatus() && !this.isSold());
    },
    // actions (other availalbe actions)
    canEditItem : function (userOrSeller) {
        return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES.EDIT_ITEM, userOrSeller);
    },
    canMakePurchase:  function (transaction) {
        var buyerCanAcceptPrivateOffer = transaction && transaction.buyerCanAcceptPrivateOffer();
        var canPurchaseOnHoldItem = this.isOnHold() && buyerCanAcceptPrivateOffer;
        return (
            !this.isNotListed() &&
            !this.isDeletedStatus() &&
            !this.dealerSuspended() &&
            !this.dealerClosed() &&
            !this.dealerPending() &&
            !this.isSold() &&
            (!this.isOnHold() || canPurchaseOnHoldItem) &&
            (!this.isPriceHidden() || buyerCanAcceptPrivateOffer)
        );
    },
    /**
     * Returns true if the item has a data review that is assignable by the given user
     * @param {User} user
     * @returns {boolean}
     */
    canAssignDataReview: function (user) {
        var review = this.getDataReview();
        assert(user instanceof User, 'You must include a user when checking to see if a data review can be assigned');
        return !!(review && review.canAssignReview(user));
    },
    /**
     * Returns true if the item has a photo review that is assignable by the given user
     * @param {User} user
     * @returns {boolean}
     */
    canAssignPhotoReview: function (user) {
        var review = this.getPhotoReview();
        assert(user instanceof User, 'You must include a user when checking to see if a photo review can be assigned');
        return !!(review && review.canAssignReview(user));
    },
    canAttachListings : function () {
        // In the future this will be based on an available action but for now, we just look at the listings
        var allListings = this.getListings().filterCanAttachListings();
        var unsavedListingsSize = allListings.filterUnsaved().size();
        var deletedListingsSize = allListings.filterDeleted().size();

        //Returns true if the number of saved listings equals the number of deleted listings
        return (allListings.get('documents').size() - unsavedListingsSize) === deletedListingsSize;
    },
    canUnlist : function (userOrSeller) {
        return this.get('actions') && this.get('actions').isUserAuthorizedFor(Item.ACTION_NAMES.UNLIST_ITEM, userOrSeller);
    },

    isTradeReturnAvailable: function () {
        var price = this.get('pricing').getMostRelevantPrice(FinancialAmount.CURRENCY_USD, true);
        return (this.isFurniture() || this.isArt()) &&
            price <= 35000 &&
            this.get('seller.shippingAddress.country') === 'US';
    },

    getActiveSalePrice: function () {
        var priceArr = this.get('pricing.prices').toJSON() || [];
        return priceArr.filter(function (price) {
            return price.type === 'WEEKLY_SALE' && price.status === 'ACTIVE';
        })[0];
    },

    hasActiveSalePrice: function () {
        return !!this.getActiveSalePrice();
    },

    deleteSalePrice: function () {
        var salePrice;
        if (this.hasActiveSalePrice()) {
            salePrice = new FinancialAmount(this.getActiveSalePrice());
            salePrice.set('status', 'INACTIVE');
            // Need to pass { merge: true } option since we're going to overwrite the existing price with the same id
            this.get('pricing.prices').add(salePrice, { merge: true });
        }
        return this;
    },
    /**
     * Need this method for the pdp to fetch price/shipping data
     * This should be replaced with a graphql
     * implementation in the future
     * @param options
     * @returns {*|null}
     */
    fetchKeyFields: function (options) {
        var self = this;

        options = options || {};
        options.data = _.extend({}, {
            fields: 'key',
            shipmentQuotesView: 'PDP'
        }, options.data);

        /* eslint-disable camelcase */
        if (!this._fetchKeyFields_P) {
            this._fetchKeyFields_P = this.fetch(options).fail(function () {
                self._fetchKeyFields_P = null;
            });
        }
        return this._fetchKeyFields_P;
        /* eslint-disable camelcase */
    }
}, transitionMixin);


// Static functions
_.extend(Item, {
    STATUS: {
        UNAVAILABLE: 'UNAVAILABLE',
        COMPLETE: 'COMPLETE',
        INCOMPLETE: 'INCOMPLETE',
        NEW: 'NEW',
        DELETED: 'DELETED'
    },
    REASON_CODE: {
        ITEM_SOLD: 'SOLD',
        SOLD_ON_PLATFORM: 'SOLD_ON_PLATFORM',
        ON_HOLD: 'ON_HOLD',
        ON_HOLD_CUSTOM: 'ON_HOLD_CUSTOM',
        UNLISTED: 'UNLISTED'
    },
    PHOTOS_API : {
        PHOTOS_API_TYPE : 'photos',
        PHOTOS_ROTATION_API_TYPE : 'photoRotationRequest',
        PHOTOS_ROTATION_TYPE : 'ROTATION'
    },
    UPLOAD_TYPE: {
        FULL_SERVICE: '_1STDIBS',
        SELF_SERVICE: 'USER'
    }
});

actionNames = {
    EDIT_ITEM : 'EDIT_ITEM',
    UNLIST_ITEM : 'UNLIST_ITEM',
    ATTACH_LISTINGS : 'ATTACH_LISTINGS',
    _XXX : 'TODO_THIS_IS_A_PLACEHOLDER_REMOVE_IT' //todo
};
_.extend(actionNames, Item.STATUS);
Object.freeze(actionNames);
_.extend(Item, {
    ACTION_NAMES: actionNames
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/Item-v3.js
// module id = 574
// module chunks = 63